export const createTemplateForCloseButton = () => `
<button type="button" class="button-close js-btn-close" title="Закрыть">&#10006;
</button>
`;
